module.exports = __webpack_public_path__ + "img/download-pdf-cut-out.73e235f6.svg";